import { Suspense } from 'react'

import { CaseInformationLoader } from '../../case-information-loader/case-information-loader'
import { ProcessingTimeTrendDialog } from '../../check-case/dialogs/processing-time-trend-dialog/processing-time-trend-dialog'
import { UpdateProcessingTimeAlertDialog } from '../dialogs/update-processing-time-alert-dialog/update-processing-time-alert-dialog'
import { CaseProcessingTimeInfo } from './case-processing-time-info/case-processing-time-info'

export const CheckCaseProcessingTime = () => {
  return (
    <>
      <Suspense fallback={<CaseInformationLoader />}>
        <CaseProcessingTimeInfo />
      </Suspense>
      <UpdateProcessingTimeAlertDialog />
      <ProcessingTimeTrendDialog />
    </>
  )
}
